(function() {
  const productModule = $('.animateProductModule');
  const subtitle = $('.animateProductModule__subtitle');
  const title = $('.animateProductModule__title');
  const descriptionFirst = $('.animateProductModule__descriptionFirst');
  const descriptionSecond = $('.animateProductModule__descriptionSecond');
  const image = $('.animateProductModule__image');
  const buttons = $('.animateProductModule__buttons');

  $.jScrollability([
    {
      'selector': productModule,
      'start': function($el) { return $el.offset().top + window.innerHeight },
      'end': function($el) { return $el.offset().top + $el.height() },
      'fn': function($el, pcnt) {
        const fullPcnt = pcnt * 100;

        if (fullPcnt >= 1 && fullPcnt <= 10) {
          subtitle.css({
            'opacity': `${pcnt * 10}`,
            'transform': `translateY(${5 - (fullPcnt / 2)}vh)`,
          });
        } else {
          subtitle.css({
            'transform': `translateY(0vh)`,
          });
        }

        if (fullPcnt < 1) {
          subtitle.css({
            'opacity': '0',
          });
        }

        if (fullPcnt < 10) {
          title.css({
            'opacity': '0',
          });
        }

        if (fullPcnt < 25) {
          image.css({
            'opacity': '0',
          });
        }

        if (fullPcnt < 40) {
          buttons.css({
            'opacity': '0',
          });
        }

        if (fullPcnt < 70) {
          descriptionFirst.css({
            'opacity': '0',
            'display': 'none',
          });
        }

        if (fullPcnt < 85) {
          descriptionSecond.css({
            'opacity': '0',
            'display': 'none',
          });
        }

        if (fullPcnt >= 11 && fullPcnt <= 24) {
          title.css({
            'opacity': `${(pcnt - (11 / 100)) * 10}`,
            'transform': `translateY(${12 - (fullPcnt / 2)}vh)`,
          });
        } else {
          title.css({
            'transform': `translateY(0vh)`,
          });
        }

        if (fullPcnt >= 25 && fullPcnt <= 39) {
          image.css({
            'opacity': `${(pcnt - (25 / 100)) * 10}`,
            'transform': `translateY(${19.5 - (fullPcnt / 2)}vh)`,
          });
        } else {
          image.css({
            'transform': `translateY(0vh)`,
          });
        }

        if (fullPcnt >= 40 && fullPcnt <= 54) {
          buttons.css({
            'opacity': `${(pcnt - (40 / 100)) * 10}`,
            'transform': `translateY(${27 - (fullPcnt / 2)}vh)`,
          });
        } else {
          buttons.css({
            'transform': `translateY(0vh)`,
          });
        }

        if (fullPcnt >= 55 && fullPcnt <= 69) {
          subtitle.css({
            'opacity': `${1 - ((pcnt - (55 / 100)) * 10)}`,
            'transform': `translateY(${Math.min(Math.max(1 - ((pcnt - (55 / 100)) * 40), -100), 0)}vh)`,
          });

          title.css({
            'opacity': `${1 - ((pcnt - (55 / 100)) * 10)}`,
            'transform': `translateY(${Math.min(Math.max(1 - ((pcnt - (55 / 100)) * 40), -100), 0)}vh)`,
          });
        }

        if (fullPcnt >= 70 && fullPcnt <= 84) {
          descriptionFirst.css({
            'display': 'block',
            'opacity': `${(pcnt - (70 / 100)) * 10}`,
            'transform': `translateY(${42 - (fullPcnt / 2)}vh)`,
          });

          subtitle.css({
            'display': 'none',
          });

          title.css({
            'display': 'none',
          });
        } else {
          descriptionFirst.css({
            'transform': `translateY(0vh)`,
          });

          subtitle.css({
            'display': 'block',
          });

          title.css({
            'display': 'block',
          });
        }

        if (fullPcnt >= 85 && fullPcnt <= 100) {
          descriptionSecond.css({
            'display': 'block',
            'opacity': `${(pcnt - (85 / 100)) * 10}`,
            'transform': `translateY(${50 - (fullPcnt / 2)}vh)`,
          });

          subtitle.css({
            'display': 'none',
          });

          title.css({
            'display': 'none',
          });
        } else {
          descriptionSecond.css({
            'transform': `translateY(0vh)`,
          });

          subtitle.css({
            'display': 'block',
          });

          title.css({
            'display': 'block',
          });
        }
      }
    }
  ]);
})();
